export default "__VITE_ASSET__Dp_XQK35__"